import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/mills.jpg"

class Mills extends Component {
  static displayName = "Mills"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { styles, elements, ...props } = this.props
    const customFieldCount = elements.custom.length
    const stackedDisplay = customFieldCount > 0

    return (
      <Form
        {...props}
        style={styles.forElement("form", {
          backgroundColor: "#f9fafb",
          backgroundImage: "",
          borderRadius: 4
        })}
      >
        <div
          style={styles.forElement("background")}
          className="formkit-background"
        />
        <div data-style="minimal">
          <Elements.Header
            tag="h2"
            name="header"
            defaults={{ content: "Join the Newsletter" }}
          />
          <Elements.Content
            name="subheader"
            defaults={{
              content: "Subscribe to get our latest content by email."
            }}
          />
          <Elements.Errors />

          <Elements.CustomFields data-stacked={stackedDisplay}>
            {stackedDisplay && <Elements.AddFieldButton />}
            <Elements.Button
              name="submit"
              group="button"
              defaults={{ content: "Subscribe" }}
            />
          </Elements.CustomFields>

          {!stackedDisplay && <Elements.AddFieldButton />}

          <Elements.Content
            name="guarantee"
            defaults={{
              content: "We won't send you spam. Unsubscribe at any time."
            }}
          />

          <Elements.BuiltWith background="form" image="background" />
        </div>
      </Form>
    )
  }
}

Mills.displayName = "Mills"

export default Mills
